// import axios from 'axios';
// import { base_url } from '../../utils/axiosConfig';

// const getConfig = () => {
//   const customer = JSON.parse(localStorage.getItem("customer"));
//   const token = customer?.token;
//   return {
//     headers: {
//       Authorization: `Bearer ${token}` || '',
//       Accept: 'application/json',
//       'Content-Type': 'application/json',
//     },
//   };
// };
// console.log(getConfig);

// const register = async (userData) => {
//   try {
//     const response = await axios.post(`${base_url}user/register`, userData);
//     if (response.data) {
//       localStorage.setItem("customer", JSON.stringify(response.data));
//       return response.data;
//     }
//     throw new Error("No data received from registration.");
//   } catch (error) {
//     throw new Error(error.response?.data?.message || "Registration failed.");
//   }
// };

// const login = async (userData) => {
//   try {
//     const response = await axios.post(`${base_url}user/login`, userData);
//     if (response.data) {
//       localStorage.setItem("customer", JSON.stringify(response.data));
//       return response.data;
//     }
//     throw new Error("No data received from login.");
//   } catch (error) {
//     throw new Error(error.response?.data?.message || "Login failed.");
//   }
// };

// const addToCart = async (cartData) => {
//   try {
//     const response = await axios.post(`${base_url}user/addcart`, cartData, getConfig());
//     if (response.data) {
//       return response.data;
//     }
//     throw new Error("No data received from add to cart.");
//   } catch (error) {
//     throw new Error(error.response?.data?.message || "Failed to add item to cart.");
//   }
// };

// // const syncCart = async (cartItems) => {
// //   try {
// //     const response = await axios.post(`${base_url}user/sync`, { cart: cartItems }, getConfig());
// //     if (response.data) {
// //       return response.data;
// //     }
// //     throw new Error("No data received from cart sync.");
// //   } catch (error) {
// //     throw new Error(error.response?.data?.message || "Failed to sync cart.");
// //   }
// // };

// const getUserWishlist = async () => {
//   try {
//     const response = await axios.get(`${base_url}user/wishlist`, getConfig());
//     if (response.data) {
//       return response.data;
//     }
//     throw new Error("No data received from wishlist.");
//   } catch (error) {
// console.log(error);

//   }
// };

// const getCart = async () => {
//   try {
//     const response = await axios.get(`${base_url}user/cart`, getConfig());
//     if (response.data) {
//       return response.data;
//     }
//     throw new Error("No data received from cart.");
//   } catch (error) {
//    console.log(error)
//   }
// };

// const updateCartQuantity = async ({ cartItemId, quantity }) => {
//   try {
//     const response = await axios.put(`${base_url}user/updatecart`, { cartItemId, quantity }, getConfig());
//     return response.data;
//   } catch (error) {
//     throw new Error(error.response?.data?.message || "Failed to update cart quantity");
//   }
// };

// const updateProfile = async (data) => {
//   try {
//     const response = await axios.put(`${base_url}user/edit-user`, data, getConfig());
//     return response.data;
//   } catch (error) {
//     throw new Error(error.response?.data?.message || "Failed to update profile");
//   }
// };

// const updateAddress = async (data) => {
//   try {
//     const response = await axios.put(`${base_url}user/save-address`, data, getConfig());
//     return response.data;
//   } catch (error) {
//     throw new Error(error.response?.data?.message || "Failed to update address");
//   }
// };

// const updatePassword = async (data) => {
//   try {
//     const response = await axios.put(`${base_url}user/password`, data, getConfig());
//     console.log(response);
    
//     return response.data;
//   } catch (error) {
//     throw new Error(error.response?.data?.message || "Failed to update password");
//   }
// };

// const getUserOrders = async () => {
//   try {
//     const response = await axios.get(`${base_url}user/get-orders`, getConfig());
//     return response.data;
//   } catch (error) {
//     throw new Error(error.response?.data?.message || "Failed to fetch orders");
//   }
// };
// const forgotPassword = async (email) => {
//   try {
//     await axios.post(`${base_url}forgot-password`, { email });
//     return { message: "Password reset email sent" };
//   } catch (error) {
//     throw new Error(error.response?.data?.msg || "Failed to send reset email");
//   }
// };

// const resetPassword = async ({ token, password }) => {
//   try {
//     await axios.put(`${base_url}reset-password/${token}`, { password });
//     return { message: "Password reset successfully" };
//   } catch (error) {
//     throw new Error(error.response?.data?.msg || "Failed to reset password");
//   }
// };


// const getOrderById = async (orderId) => {
//   try {
//     const response = await axios.get(`${base_url}user/getidorder/${orderId}`, getConfig());
//     return response.data;
//   } catch (error) {
//     throw new Error(error.response?.data?.message || "Failed to fetch order details");
//   }
// };

// const repeatOrder = async (orderData) => {
//   try {
//     const response = await axios.post(`${base_url}user/cart/create-order`, orderData, getConfig());
//     return response.data;
//   } catch (error) {
//     throw new Error(error.response?.data?.message || "Failed to repeat order");
//   }
// };
// const getUserProfile = async (id) => {
//   try {
  
//     const response = await axios.get(`${base_url}user/profile/${id}`, getConfig());
//     console.log('getUserProfile raw response:', response.data); // Debug
//     const userData = response.data.user || response.data.data || response.data;
//     if (!userData || typeof userData !== 'object' || !userData._id) {
//       throw new Error('No valid user data received');
//     }
//     console.log('getUserProfile normalized user:', userData);
//     return { user: userData };
//   } catch (error) {
//     console.error('getUserProfile error:', error.response?.data || error.message);
//     throw new Error(error.response?.data?.error || error.message || 'Failed to fetch user profile');
//   }
// };
// export const authService = {
//   register,
//   login,
//  addToCart,
//   // syncCart,
//   getUserWishlist,
//   getCart,
//   updateCartQuantity,
//  updateProfile,
//  updateAddress,
//  updatePassword,
//  getUserOrders,
//  forgotPassword,
//  resetPassword,
//  getOrderById,
//  repeatOrder,
//  getUserProfile
// };



import axios from 'axios';
import { base_url } from '../../utils/axiosConfig';

const getConfig = () => {
  const customer = JSON.parse(localStorage.getItem("customer"));
  const token = customer?.token;
  return {
    headers: {
      Authorization: `Bearer ${token}` || '',
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  };
};

const register = async (userData) => {
  try {
    const response = await axios.post(`${base_url}user/register`, userData);
    if (response.data) {
      localStorage.setItem("customer", JSON.stringify(response.data));
      return response.data;
    }
    throw new Error("No data received from registration.");
  } catch (error) {
    throw new Error(error.response?.data?.message || "Registration failed.");
  }
};

const login = async (userData) => {
  try {
    const response = await axios.post(`${base_url}user/login`, userData);
    if (response.data) {
      localStorage.setItem("customer", JSON.stringify(response.data));
      return response.data;
    }
    throw new Error("No data received from login.");
  } catch (error) {
    throw new Error(error.response?.data?.message || "Login failed.");
  }
};

const addToCart = async (cartData) => {
  try {
    const response = await axios.post(`${base_url}user/addcart`, cartData, getConfig());
    if (response.data) {
      return response.data;
    }
    throw new Error("No data received from add to cart.");
  } catch (error) {
    throw new Error(error.response?.data?.message || "Failed to add item to cart.");
  }
};

const getUserWishlist = async () => {
  try {
    const response = await axios.get(`${base_url}user/wishlist`, getConfig());
    if (response.data) {
      return response.data;
    }
  } catch (error) {
    console.error("getUserWishlist error:", error);
    return []; // Return empty array on error
  }
};



const getCart = async () => {
  try {
    const response = await axios.get(`${base_url}user/cart`, getConfig());
    if (response.data) {
      return response.data;
    }
    return []; // Return empty array if no data
  } catch (error) {
    console.error("getCart error:", error);
    return []; // Return empty array on error
  }
};

const updateCartQuantity = async ({ cartItemId, quantity }) => {
  try {
    const response = await axios.put(`${base_url}user/updatecart`, { cartItemId, quantity }, getConfig());
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Failed to update cart quantity");
  }
};

const updateProfile = async (data) => {
  try {
    const response = await axios.put(`${base_url}user/edit-user`, data, getConfig());
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Failed to update profile");
  }
};

const updateAddress = async (data) => {
  try {
    const response = await axios.put(`${base_url}user/save-address`, data, getConfig());
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Failed to update address");
  }
};

const updatePassword = async (data) => {
  try {
    const response = await axios.put(`${base_url}user/password`, data, getConfig());
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Failed to update password");
  }
};

const getUserOrders = async () => {
  try {
    const response = await axios.get(`${base_url}user/get-orders`, getConfig());
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Failed to fetch orders");
  }
};

const forgotPassword = async (email) => {
  try {
    await axios.post(`${base_url}forgot-password`, { email });
    return { message: "Password reset email sent" };
  } catch (error) {
    throw new Error(error.response?.data?.msg || "Failed to send reset email");
  }
};

const resetPassword = async ({ token, password }) => {
  try {
    await axios.put(`${base_url}reset-password/${token}`, { password });
    return { message: "Password reset successfully" };
  } catch (error) {
    throw new Error(error.response?.data?.msg || "Failed to reset password");
  }
};

const getOrderById = async (orderId) => {
  try {
    const response = await axios.get(`${base_url}user/getidorder/${orderId}`, getConfig());
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Failed to fetch order details");
  }
};

const repeatOrder = async (orderData) => {
  try {
    const response = await axios.post(`${base_url}user/cart/create-order`, orderData, getConfig());
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Failed to repeat order");
  }
};

const getUserProfile = async (id) => {
  try {
    const response = await axios.get(`${base_url}user/profile/${id}`, getConfig());
    console.log('getUserProfile raw response:', response.data);
    const userData = response.data.user || response.data.data || response.data;
    if (!userData || typeof userData !== 'object' || !userData._id) {
      throw new Error('No valid user data received');
    }
    console.log('getUserProfile normalized user:', userData);
    return { user: userData };
  } catch (error) {
    console.error('getUserProfile error:', error.response?.data || error.message);
    throw new Error(error.response?.data?.error || error.message || 'Failed to fetch user profile');
  }
};

export const authService = {
  register,
  login,
  addToCart,
  getUserWishlist,
  getCart,
  updateCartQuantity,
  updateProfile,
  updateAddress,
  updatePassword,
  getUserOrders,
  forgotPassword,
  resetPassword,
  getOrderById,
  repeatOrder,
  getUserProfile,
};